var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"all-work-page",class:{
		'all-work-page_mobile': _vm.mobileMode,
		'all-work-page_desktop': !_vm.mobileMode,
	}},[(_vm.mobileMode)?_c('filter-panel'):_vm._e(),_c('grid-layout',{attrs:{"tiles":_vm.tiles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }